import { hexToRgb } from '@website/common/utils'
export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blockTitle: p => p.accentWhite,
    socialColor: p => p.accentWhite,
    socialBorder: p => p.accentWhite,
    navbarBg: p => p.tertiaryDark,
    background: p => p.tertiaryDark,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryDark,
    backgroundDark: p => `rgba(${hexToRgb(p.primaryLight)}, 0.6)`
  },
  LIGHT: {
    heading: p => p.primaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.accentWhite,
    socialColor: p => p.tertiaryDark,
    socialBorder: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryLight,
    background: p => p.tertiaryLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryLight,
    backgroundDark: p => `rgba(${hexToRgb(p.primaryDark)}, 0.6)`
  },
  EXTRALIGHT: {
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryDark,
    blockTitle: p => p.accentWhite,
    socialColor: p => p.tertiaryDark,
    socialBorder: p => p.tertiaryDark,
    navbarBg: p => p.tertiaryExtraLight,
    background: p => p.tertiaryExtraLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight,
    backgroundDark: p => `rgba(${hexToRgb(p.primaryDark)}, 0.6)`
  }
}
